import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import TalkToExpert from "../components/LandingPage/TalkToExpert";
import Testmonials from "../components/LandingPage/Testmonials";
import OtherLayout from "../components/Layout/OtherLayout";
import axios from "axios";
import noresult from "../images/noresult.png";
import "../Style/CategoryListPage/Category.css";
import blogBG from "../images/blogs/blog.jpg";

const CategoryBlogPage = () => {
  const params = useParams();
  const navigate = useNavigate();
const [blogs, setBlogs] = useState([]);
  const [singleBlog, setSingleBlog] = useState(null);

  async function getAllBlogs() {
    try {
      const res = await axios.get("/api/blog/get-all-blog");
      if (res.data.success) {
        setBlogs(res.data.data.reverse());
        singleBlogFilter(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
 function singleBlogFilter(blogs) {
  if (!Array.isArray(blogs) || blogs.length === 0) {
    setSingleBlog(null);
    return;
  }

  const decodedCategory = decodeURIComponent(params.category || "")
    .replace(/-/g, " ")
    .toLowerCase()
    .trim();

  const sblog = blogs.filter(
    (item) =>
      item?.title?.toLowerCase().trim() === decodedCategory
  );

  console.log("Decoded Category:", decodedCategory);
  console.log("Filtered Blog Result:", sblog);

  if (sblog && sblog.length > 0) {
    setSingleBlog(sblog[0]);
  } else {
    setSingleBlog(null);
  }
}


  useEffect(() => {
    getAllBlogs();
  }, []);

  const calculateReadingTime = (text) => {
    const wordsPerMinute = 200; // Adjust this value based on the average reading speed
    const wordCount = text.trim().split(/\s+/).length;
    const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);
    return readingTimeMinutes;
  };

  function handleNavigate(title) {
    navigate(`/blog/${title.replace(/\s+/g, "-")}`);
  }

  useEffect(() => {
    singleBlogFilter(blogs);
  }, [params.category]);

  return (
    <OtherLayout
      background={`/blogImages/${singleBlog?.image}`}
      title={singleBlog?.title}
      extraSubTitle={singleBlog?.category}
    >
      <div className="blog-display-container Mon_font">
       {singleBlog ? (
  <div className="blog-display">
    <h4>{singleBlog.title}</h4>
<div
  className="blog-content"
  dangerouslySetInnerHTML={{ __html: singleBlog.description }}
></div>
    <p className="mb-0">
      <b>Written by - {singleBlog.author}</b>
    </p>
    <p className="m-0">
      {new Date(singleBlog.createdAt).toLocaleString("default", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}
    </p>
  </div>
) : (
  <div className="no-blog">
    <img src={noresult} alt="No blog found" />
    <p>No blog found for this category.</p>
  </div>
)}

      <div className="more-blogs">
  <h4>Trending Blogs</h4>
  <hr className="mt-0" />
  {blogs && blogs.filter((b) => b.trending === true).length === 0 ? (
    <p>No trending blogs available.</p>
  ) : (
    blogs
      .filter((item) => item.trending === true)
      .slice(0, 10) // limit to 10 if you want
      .map((item, index) => (
        <div
          key={index}
          className="recent-blog"
          onClick={() => handleNavigate(item?.title)}
        >
          <div className="recent-blog-img">
            <img src={`/blogImages/${item?.image}`} alt={item?.title} />
          </div>
          <div className="recent-blog-content">
            <h6>{item?.title}</h6>
            <p className="m-0">
              <span>
                <small>
                  {new Date(item?.createdAt).toLocaleString("default", {
                    day: "numeric",
                    month: "long",
                  })}
                </small>
              </span>
              {" | "}
              <span>
                <small>
                  {calculateReadingTime(item.description)} min Read
                </small>
              </span>
            </p>
          </div>
        </div>
      ))
  )}
</div>

      </div>
      <TalkToExpert />
    </OtherLayout>
  );
};

export default CategoryBlogPage;
